module.exports = __webpack_public_path__ + "media/goforajourney/img/about-us-916a8054672556b3ec7823a13bd05f78.jpg";